<template>
  <v-content>
    <!-- Form -->
    <v-card>
      <v-layout class="text-field-add-tool">
        <v-flex xs12 mt-8>
          <v-form ref="form" v-model="valid" lazy-validation>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                เลขที่ สป.​ :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.spec_no"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="idSpRules"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                หมายเลข สป. :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.spec_code"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="noSpRules"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                ชื่อ สป. (ไทย) :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.name_th"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="nameSpTHRules"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                ชื่อ สป. (อังกฤษ) :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.name_en"
                  background-color="#E5E5E5"
                  solo
                  flat
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                หน่วยนับ :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.unit"
                  background-color="#E5E5E5"
                  solo
                  flat
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                ปีที่จัดทำ :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.year"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="yearsTHRules"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                Commld :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.comm_id"
                  background-color="#E5E5E5"
                  solo
                  flat
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                แนบเอกสาร :
              </v-flex>
              <v-flex xs6>
                <v-file-input
                  v-model="form.path_file"
                  label="File input"
                  outlined
                  dense
                  solo
                  show-size
                  hide-details
                  flat
                ></v-file-input>
              </v-flex>
            </v-layout>

            <v-layout v-if="form.path_file != ''" style="margin-right: 13em" mb-6 mt-1>
              <v-flex>
                <a :href="serverName+form.path_file">Download File</a>
              </v-flex>
            </v-layout>
            <v-layout v-else style="margin-right: 13em;" mb-6 mt-1>
              <v-flex>
                <a style="cursor: not-allowed;opacity: 0.5;text-decoration: none;">Download File</a>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                ประเภท :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.type_spec"
                  background-color="#E5E5E5"
                  solo
                  flat
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                สถานะอุปกรณ์ :
              </v-flex>
              <v-flex xs6>
                <v-select
                  v-model="form.status"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :items="status"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="[v => !!v || 'สถานะอุปกรณ์ is required']"
                  required
                ></v-select>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                Pass_No :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.pass_no"
                  background-color="#E5E5E5"
                  solo
                  flat
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                DepName :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.dep_name"
                  background-color="#E5E5E5"
                  solo
                  flat
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                Group Num :
              </v-flex>
              <v-flex xs6>
                <v-select
                  v-model="form.group_num"
                  :menu-props="{ bottom: true, offsetY: true }"
                  :items="optionSpec"
                  item-text="main_group_desc"
                  item-value="groupNum"
                  background-color="#E5E5E5"
                  solo
                  flat
                  :rules="[v => !!v || 'Group Num is required']"
                  required
                ></v-select>
              </v-flex>
            </v-layout>

<!--            <v-layout justify-center>-->
<!--              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">-->
<!--                Main Group :-->
<!--              </v-flex>-->
<!--              <v-flex xs6>-->
<!--                <v-select-->
<!--                  v-model="form.main_group"-->
<!--                  :menu-props="{ bottom: true, offsetY: true }"-->
<!--                  :items="options"-->
<!--                  background-color="#E5E5E5"-->
<!--                  solo-->
<!--                  flat-->
<!--                  :rules="[v => !!v || ' Main Group is required']"-->
<!--                  required-->
<!--                ></v-select>-->
<!--              </v-flex>-->
<!--            </v-layout>-->

<!--            <v-layout justify-center>-->
<!--              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">-->
<!--                Sub Group :-->
<!--              </v-flex>-->
<!--              <v-flex xs6>-->
<!--                <v-select-->
<!--                  v-model="form.sub_group"-->
<!--                  :menu-props="{ bottom: true, offsetY: true }"-->
<!--                  :items="options"-->
<!--                  background-color="#E5E5E5"-->
<!--                  solo-->
<!--                  flat-->
<!--                  :rules="[v => !!v || 'Sub Group is required']"-->
<!--                  required-->
<!--                ></v-select>-->
<!--              </v-flex>-->
<!--            </v-layout>-->

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                Workername :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.workername"
                  background-color="#E5E5E5"
                  solo
                  flat
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                Keyword :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.keyword"
                  background-color="#E5E5E5"
                  solo
                  flat
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout justify-center>
              <v-flex xs4 sm3 md2 mr-4 pt-1 style="text-align: right;">
                GPSC :
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="form.gpsc"
                  background-color="#E5E5E5"
                  solo
                  flat
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>

          </v-form>
        </v-flex>
      </v-layout>
    </v-card>

    <!-- Button -->
    <v-layout>
      <v-flex mt-8 pr-12 style="text-align: right;">

        <v-btn
          color="#BDBDBD"
          class="mr-4"
          @click="$router.push('/data-medical-equipment').catch(err => {})"
        >
          ย้อนกลับ
        </v-btn>

        <v-btn v-if="isEdit==true"
               color="#D97C57"
               class="mr-4"
               @click="deleteDataTool()"
        >
          <span style="color: white;">ลบบัญชี</span>
        </v-btn>

        <v-btn v-if="isEdit==true"
               :disabled="!valid"
               color="#527281"
               class="mr-4"
               @click="editDataTool()"
        >
          <span style="color: white;">ยืนยันการแก้ไขข้อมูล</span>
        </v-btn>

        <v-btn v-if="isAdd==true"
               :disabled="!valid"
               color="#527281"
               class="mr-4"
               @click="saveDataTool()"
        >
          <span style="color: white;">ยืนยันการสร้างข้อมูลใหม่</span>
        </v-btn>
      </v-flex>
    </v-layout>

  </v-content>
</template>

<script>
  import validate from "../utils/validate";
  import Service from '../service';
  import Multiselect from 'vue-multiselect';

    export default {
        created() {
            if (this.$route.params.id) {
                this.getDataToolEdit();
            }
            this.getSpecGroup();
        },
        name: "FormDataTool",
        props: {
            isEdit: {
                type: Boolean,
                default: false,
            },
            isAdd: {
                type: Boolean,
                default: false,
            }
        },
        components: {
          Multiselect,
        },
        data: () => ({
            serverName: process.env.VUE_APP_URL_API,
            optionSpec:[],
            status: [
                {text:'ใช้งาน', value: '1'},
                // {text:'รอยกเลิก', value: '2'},
                {text:'ยกเลิก', value: '3'}
            ],
            valid: true,
            form: {
                spec_no: '',
                spec_code: '',
                name_th: '',
                name_en: '',
                unit: '',
                year: '',
                comm_id: '',
                path_file: [],
                type_spec: '',
                status: '',
                pass_no: '',
                dep_name: '',
                group_num: '',
                main_group:'',
                sub_group:'',
                gpsc: '',
                workername: '',
                keyword: '',

            },
            idSpRules: [
                v => validate.required(v, "เลขที่ สป"),
            ],
            noSpRules: [
                v => validate.required(v, "หมายเลข สป"),
            ],
            nameSpTHRules: [
                v => validate.required(v, "ชื่อ สป. (ไทย)"),
            ],
            yearsTHRules: [
                v => validate.required(v, "ปีที่จัดทำ"),
            ],
        }),
        methods: {
            validate() {
                if (this.$refs.form.validate()) {
                    this.snackbar = true
                }
            },

            async saveDataTool() {
                if(this.$refs.form.validate() == false) {
                    console.log('Error');
                } else {
                    confirm('Do you want to save Data Tool ?');
                    let result = await Service.MedicalTool.saveDataTools({
                        spec_no: this.form.spec_no,
                        spec_code: this.form.spec_code,
                        name_th: this.form.name_th,
                        name_en: this.form.name_en,
                        unit: this.form.unit,
                        year: this.form.year,
                        comm_id: this.form.comm_id,
                        path_file: this.form.path_file,
                        type_spec: this.form.type_spec,
                        status: this.form.status,
                        pass_no: this.form.pass_no,
                        dep_name: this.form.dep_name,
                        group_num: this.form.group_num,
                        gpsc: this.form.gpsc,
                        workername: this.form.workername,
                        keyword: this.form.keyword,
                    })
                    // console.log(result)
                    if (result) {
                        alert('Save Success')
                    } else {
                        alert('Save Error')
                    }
                }
            },
            async deleteDataTool() {
                // console.log(this.$route.params.id)
                confirm('Do you want to delete Data Tool ID : '+this.$route.params.id);

                let result = await Service.MedicalTool.deleteDataTool(this.$route.params.id)

                if (result) {
                    alert("Delete Success")
                    this.$router.push('/data-medical-equipment').catch(err => {})
                }else {
                    alert("Delete Failed")
                }
            },
            getDataToolEdit() {
                return  Service.MedicalTool.getDataToolEdit(this.$route.params.id).then(data => {
                    // console.log(data)
                    this.form.spec_no = data.spec_no;
                    this.form.spec_code = data.spec_code;
                    this.form.name_th = data.name_th;
                    this.form.name_en = data.name_en;
                    this.form.unit = data.unit;
                    this.form.year = data.year;
                    this.form.comm_id = data.comm_id;
                    this.form.path_file = [data.path_file];
                    this.form.type_spec = data.type_spec;
                    this.form.status = data.status;
                    this.form.pass_no = data.pass_no;
                    this.form.dep_name = data.dep_name;
                    this.form.group_num = data.group_num;
                    this.form.gpsc = data.gpsc;
                    this.form.workername = data.workername;
                    this.form.keyword = data.keyword;
                })
            },
            getSpecGroup() {
              Service.MedicalTool.getSpecGroup().then(data => {
                  // console.log(data)
                  data.forEach(specGroup => {
                      this.optionSpec.push({
                          groupNum: `${specGroup.group_main}`,
                          main_group_desc: `${specGroup.main_group_desc}`
                      });
                  })
              })
            },
            editDataTool() {
                if(this.$refs.form.validate() == false) {
                    console.log('Error');
                } else {
                    // confirm('Do you want to Edit Data Tool ID : '+this.$route.params.id);
                    // console.log(this.form)
                    let result = Service.MedicalTool.editDataTool(this.$route.params.id, {
                        spec_no: this.form.spec_no,
                        spec_code: this.form.spec_code,
                        name_th: this.form.name_th,
                        name_en: this.form.name_en,
                        unit: this.form.unit,
                        year: this.form.year,
                        comm_id: this.form.comm_id,
                        path_file: this.form.path_file,
                        type_spec: this.form.type_spec,
                        status: this.form.status,
                        pass_no: this.form.pass_no,
                        dep_name: this.form.dep_name,
                        group_num: this.form.group_num,
                        gpsc: this.form.gpsc,
                        workername: this.form.workername,
                        keyword: this.form.keyword,
                    })

                    if (result) {
                        alert('Edit Success');
                        // this.$router.push({ path: '/manage-user-accounts', query: { activeTab: 2 } });
                    }else {
                        alert('Edit Error...');
                    }
                }
            }

        }
    }
</script>

<style lang="scss">
  .text-field-add-tool {
    .v-text-field.v-text-field--solo .v-input__control {
      min-height: auto;
    }
    .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
      color: #527281;
    }
    .theme--light.v-select .v-select__selections {
      color: #527281;
    }
    i.v-icon.notranslate.mdi.mdi-menu-down.theme--light.primary--text {
      color: #527281!important;
    }
    .theme--light.v-file-input .v-file-input__text {
      color: #527281;
    }
    .v-text-field--filled.v-input--dense>.v-input__control>.v-input__slot, .v-text-field--full-width.v-input--dense>.v-input__control>.v-input__slot, .v-text-field--outlined.v-input--dense>.v-input__control>.v-input__slot {
      min-height: auto!important;
    }
  }
</style>
